import React from "react";
import MediaImage from "./MediaImage";
import useContent from "../hooks/useContent";
import "./Gallery.css";

/**
 * One album of the owner's gallery (contract v1.3 §3.13.1 `gallery`: album,
 * image, caption). `album="about"` is her artwork and photos on the About
 * page; `album="groups"` is the free groups' album on Groups & Workshops.
 * Bundled seed images until the API answers; an item whose image is missing
 * (deleted media) is skipped, and the whole section is left out when
 * nothing remains.
 *
 * @param {object} props
 * @param {'about'|'groups'} props.album
 * @param {string} [props.heading]
 * @param {2|3} [props.headingLevel] - 3 inside another section, default 2
 */
export default function Gallery({ album, heading = "Gallery", headingLevel = 2 }) {
  const { items } = useContent("gallery");
  const shown = items.filter(
    (item) => item.data && item.data.album === album && item.data.image && item.data.image.kind === "image"
  );
  if (shown.length === 0) return null;

  const headingId = `gallery-${album}-heading`;
  const Heading = `h${headingLevel}`;
  return (
    <section className="gallery-wrap" aria-labelledby={headingId}>
      <Heading id={headingId}>{heading}</Heading>
      <ul className="gallery-grid">
        {shown.map((item) => (
          <li key={item.slug}>
            <figure className="gallery-item">
              <MediaImage
                media={item.data.image}
                className="gallery-img"
                sizes="(max-width: 600px) 50vw, 300px"
              />
              {item.data.caption ? <figcaption>{item.data.caption}</figcaption> : null}
            </figure>
          </li>
        ))}
      </ul>
    </section>
  );
}
